import { Conta } from './../../model/financeiro/conta';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';

@Injectable({
  providedIn: 'root'
})
export class ContaService extends GenericService<Conta>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("conta")
  }
}
